export const FETCH_APPLICATION_CENTER_DOCUMENTS =
  'applicationCenter/FETCH_APPLICATION_CENTER_DOCUMENTS';
export const FETCH_APPLICATION_CENTER_DOCUMENTS_SUCCESS =
  'applicationCenter/FETCH_APPLICATION_CENTER_DOCUMENTS_SUCCESS';
export const FETCH_APPLICATION_CENTER_DOCUMENTS_FAILURE =
  'applicationCenter/FETCH_APPLICATION_CENTER_DOCUMENTS_FAILURE';

export const SUBMIT_APPLICATION_CENTER_DOCUMENTS =
  'applicationCenter/SUBMIT_APPLICATION_CENTER_DOCUMENTS';
export const SUBMIT_APPLICATION_CENTER_DOCUMENTS_SUCCESS =
  'applicationCenter/SUBMIT_APPLICATION_CENTER_DOCUMENTS_SUCCESS';
export const SUBMIT_APPLICATION_CENTER_DOCUMENTS_FAILURE =
  'applicationCenter/SUBMIT_APPLICATION_CENTER_DOCUMENTS_FAILURE';

export const action = <T>(type: string, payload?: T): IAction => ({
  type,
  payload,
});

export const actionSuccess = <T>(type: string, payload: T): IAction => ({
  type: `${type}_SUCCESS`,
  payload,
});

export const actionFailure = <T>(type: string, payload: T): IAction => ({
  type: `${type}_FAILURE`,
  payload,
});
